<template>
  <div>
    <Header name="Indicação de Rede" titleLabel="indicação de Rede" />
    <omint-page-content>
      <CBox mb="24px">
        <OmtTypography as="h1-bold" lineHeight="32px">Realize sua solicitação por:</OmtTypography>
      </CBox>

      <CBox mb="4">
        <AffiliateIndicationTile
          :hasCountainer="true"
          :hasHoverEffect="true"
          icon="fa fa-message-plus"
          title="Mensagem"
          subtitle="Detalhe a solicitação direto pelo app"
          link="/indicacao-de-credenciados/formulario"
        />
      </CBox>

      <CBox>
        <AffiliateIndicationTile
          :hasCountainer="true"
          :hasHoverEffect="true"
          icon="fa fa-video"
          title="Teleatendimento"
          subtitle="Detalhe a solicitação por uma videochamada"
          link="/agendamento/indicacao"
        />
      </CBox>
    </omint-page-content>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Molecules/Header";
import Footer from "@/components/Molecules/Footer";
import AffiliateIndicationTile from "@/components/Organisms/AffiliateIndication/Tile";
import { CBox } from "@chakra-ui/vue";

export default {
  name: "AffiliateIndicationMenu",
  components: { Footer, Header, AffiliateIndicationTile, CBox },
  mounted() {
    setTimeout(() => {
      this.$root.$emit("hide-loading");
    }, 0);
  }
};
</script>
